var exports = {
  "h": "xdde3148b--07df80--description",
  "P": "xdde3148b--07df80--markup",
};

module.exports = exports;
